import { render, staticRenderFns } from "./InquiryFloat.vue?vue&type=template&id=37b6310a&scoped=true"
import script from "./InquiryFloat.vue?vue&type=script&lang=js"
export * from "./InquiryFloat.vue?vue&type=script&lang=js"
import style0 from "./InquiryFloat.vue?vue&type=style&index=0&id=37b6310a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b6310a",
  null
  
)

export default component.exports